import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
import { Content } from 'antd/es/layout/layout';
import layoutStyles from 'components/Layout/Layout.module.scss';
import { selectUserSignInStatus } from 'services/session/sessionSelectors';

function UnAuthRoute() {
  const isLogin = useAppSelector(selectUserSignInStatus);
  const location = useLocation();

  if (isLogin) {
    return (
      <Navigate
        to={{ pathname: '/dashboard', search: location.search }}
        replace
      />
    );
  }

  return (
    <Content className={layoutStyles.content}>
      <Outlet />
    </Content>
  );
}

export default UnAuthRoute;
